import { gql } from "@apollo/client";

export const CREATE_COURSE = gql`
  mutation CreateCourse($input: createCourseInput) {
    createCourse(input: $input) {
      courseId
    }
  }
`;















export const UPDATE_COURSE = gql`
  mutation UpdateCourse($input: updateCourseInput) {
    updateCourse(input: $input)
  }
`;

